import React from 'react';
import type {List} from 'immutable';
import type {SchoolModelV5} from 'resources/augmented/School/SchoolModel.v5';

import {Text, LoadingSpinner} from '@albert-io/atomic';

import SchoolSearchResultsList from './SchoolSearchResultsList.react';

interface Props {
  schoolNameSearchValue?: string;
  isLoadingResults?: boolean;
  results: List<SchoolModelV5>;
  selected?: SchoolModelV5 | SchoolModelV5[];
  setSelected?: (school: SchoolModelV5) => void;
  onSubmit: () => void;
  shouldShowHelpText?: boolean;
  errorMessage?: React.ReactNode;
  multiSelect?: boolean;
  hasExistingRecord?: (schoolId: string) => boolean | undefined;
  hideFooter?: boolean;
  setMaxHeight?: boolean;
}

const SchoolSearchResults = ({
  schoolNameSearchValue,
  isLoadingResults,
  results,
  selected,
  setSelected,
  onSubmit,
  shouldShowHelpText,
  errorMessage,
  multiSelect,
  hasExistingRecord,
  hideFooter,
  setMaxHeight
}: Props) => {
  if (!schoolNameSearchValue) {
    // return list of only selected items if there's no search term
    return multiSelect ? (
      <SchoolSearchResultsList
        results={selected}
        selected={selected}
        setSelected={setSelected}
        onSubmit={() => onSubmit()}
        shouldShowHelpText={shouldShowHelpText}
        errorMessage={errorMessage}
        multiSelect={multiSelect}
        onlyShowChips
        hasExistingRecord={hasExistingRecord}
        hideFooter={hideFooter}
      />
    ) : null;
  }
  if (isLoadingResults) {
    return (
      <div className='school-lookup-modal__results-container mt-x2'>
        <div className='school-lookup-modal__results-container--border px-x2 pt-x5 pb-x3 flex flex-col items-center justify-center'>
          <LoadingSpinner size={2} />
        </div>
      </div>
    );
  }
  if (results.size === 0) {
    return (
      <div className='school-lookup-modal__results-container mt-x2'>
        <div className='school-lookup-modal__results-container--border px-x2 py-x5 flex flex-col items-center justify-center'>
          <Text bold className='mb-x1'>
            No results found.
          </Text>
          <Text> Try modifying your search.</Text>
        </div>
      </div>
    );
  }
  if (results.size > 24) {
    return (
      <div className='school-lookup-modal__results-container mt-x2'>
        <div className='school-lookup-modal__results-container--border px-x2 py-x5 flex flex-col items-center justify-center'>
          <Text bold className='mb-x1'>
            Too many results.
          </Text>
          <Text> Try narrowing your search using the filters above.</Text>
        </div>
      </div>
    );
  }
  return (
    <SchoolSearchResultsList
      results={results}
      selected={selected}
      setSelected={setSelected}
      onSubmit={() => onSubmit()}
      shouldShowHelpText={shouldShowHelpText}
      errorMessage={errorMessage}
      multiSelect={multiSelect}
      hasExistingRecord={hasExistingRecord}
      hideFooter={hideFooter}
      setMaxHeight={setMaxHeight}
    />
  );
};

export default SchoolSearchResults;
